import { AnalyticsEventName } from '@mb/lib';
import { handleSystemErrorReport } from '@mb/lib/utils';
import { getUrlParameter } from './getUrlParameter';
import { mapMaterialsForAnalytics } from './mapMaterialsForAnalytics';
import { ProductSearchMaterial } from '../../../../pages/ProductSearch/types';
import { getAnalyticsDataIfCollection } from '../../../../pages/ProductSearch/utils/helpers';

export const pushSearchAnalyticsDataLayer = (
  payload: ProductSearchMaterial[] = [],
  currentColor = '',
  listId = 'mini_pdp',
  listTitle = 'Mini PDP',
  eventName = 'mini_pdp_item_list',
  eventLocation: string | null,
  isFromCatalog = false,
  isSearch = false,
) => {
  try {
    const currentQuery = getUrlParameter('q');
    let finalListId = listId;
    let finalListTitle = listTitle;

    if (isSearch || currentQuery?.length > 0) {
      finalListId = 'mini_pdp';
      finalListTitle = 'Mini PDP';
    }

    if (window.location.pathname?.includes('/curatedcollections/')) {
      const { id, title } = getAnalyticsDataIfCollection();
      finalListId = id;
      finalListTitle = title;
    }

    const { gaType, currency } = mapMaterialsForAnalytics(
      payload,
      currentColor,
      finalListId,
      finalListTitle,
      eventLocation,
    );

    const gaEvent: any = {
      event: eventName,
      list_id: finalListId,
      list_name: finalListTitle,
      ecommerce: {
        currency,
        value: 0,
        items: gaType,
      },
    };

    if (eventName === AnalyticsEventName.ADD_TO_CART) {
      gaEvent['method'] = gaType.length > 1 ? 'MULTI_SELECT' : 'SINGLE';
    }

    if (eventLocation != null) {
      gaEvent['event_location'] = eventLocation;
    }
    if (listId != null && isFromCatalog) {
      gaEvent.ecommerce['item_list_id'] = finalListId;
    }
    if (listTitle != null && isFromCatalog) {
      gaEvent.ecommerce['item_list_name'] = finalListTitle;
    }

    mitGTM.sendEvent({ ecommerce: null });
    mitGTM.sendEvent(gaEvent);
  } catch (e) {
    handleSystemErrorReport(
      `Error in pushSearchAnalyticsDataLayer: ${e.message}`,
    );
  }
};
